import {} from './global'

const Modulroutes = global.rootRequire('moduleroutes')
const Themeroutes = global.rootRequiretheme('themeroutes').default

// SERVER SIDE LOAD DATA
const routes = [].concat(Modulroutes).concat(Themeroutes)

export default routes
